// src/components/Projects.js
import React, { useEffect, useState } from 'react';
import { Card, Button, Container, Row, Col, Spinner, Alert, Badge } from 'react-bootstrap';
import { profileData } from '../data/profileData';
import '../styles/Projects.css';

function Projects() {
  const [repos, setRepos] = useState([]);
  const [loading, setLoad] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRepos = async () => {
      try {
        const { username, priorityRepos } = profileData.github;
        const resp = await fetch(`https://api.github.com/users/${username}/repos?sort=updated&per_page=100`);
        
        if (!resp.ok) throw new Error('Error conectando con GitHub');
        
        const data = await resp.json();

        const sortedData = data.sort((a, b) => {
          const isAPriority = priorityRepos.some(p => a.name.includes(p));
          const isBPriority = priorityRepos.some(p => b.name.includes(p));
          
          if (isAPriority && !isBPriority) return -1;
          if (!isAPriority && isBPriority) return 1;
          return b.stargazers_count - a.stargazers_count;
        });

        setRepos(sortedData.slice(0, 9)); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoad(false);
      }
    };
    fetchRepos();
  }, []);

  return (
    <Container className="py-5 min-vh-100">
      <h2 className="text-center mb-5 display-5 fw-bold">My Projects</h2>
      
      {loading && (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {error && (
        <Alert variant="danger" className="text-center">
          See my projects on <a href={`https://github.com/${profileData.github.username}`}>GitHub</a>.
        </Alert>
      )}

      <Row className="g-4">
        {!loading && !error && repos.map(repo => (
          <Col key={repo.id} xs={12} md={6} lg={4}>
            <Card className="h-100 shadow-sm border-0 project-card">
              <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <Card.Title className="fw-bold text-primary">{repo.name}</Card.Title>
                  <Badge bg="light" text="dark" className="border">
                    ⭐ {repo.stargazers_count}
                  </Badge>
                </div>
                <Card.Text className="text-muted flex-grow-1 small">
                  {repo.description || 'Sin descripción disponible.'}
                </Card.Text>
                
                <div className="mt-3">
                   {repo.language && (
                     <Badge bg="info" className="me-2 mb-2">{repo.language}</Badge>
                   )}
                </div>
              </Card.Body>
              <Card.Footer className="bg-white border-top-0 pb-3">
                <Button 
                  variant="outline-dark" 
                  className="w-100 rounded-pill"
                  href={repo.html_url}
                  target="_blank"
                >
                  View on GitHub
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Projects;